import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { useContext } from "react";
import { AppContext } from "../context/app";
import {
  getAuthorizationCheck,
  GetCalendars,
  getCalendars,
  getGoogleCalendarEvent,
} from "./googleSyncApi";

export function useGoogleSyncAuthorization(
  userUuid: string,
  options?: UseQueryOptions<boolean>,
) {
  const app = useContext(AppContext);

  return useQuery({
    ...options,
    queryKey: ["google-sync-check", userUuid],
    queryFn: () => getAuthorizationCheck(userUuid, app.client?.uuid),
  });
}

export function useGetCalendars(
  userUuid: string,
  options?: UseQueryOptions<GetCalendars>,
) {
  const app = useContext(AppContext);

  return useQuery({
    ...options,
    queryKey: ["google-sync-calendars", userUuid],
    queryFn: () => getCalendars(userUuid, app.client?.uuid),
  });
}

export function useGoogleCalendarQuery(clientId: string, minDateTime: string, maxDateTime: string, options?: UseQueryOptions<any[]>) {
  const app = useContext(AppContext);
  return useQuery<any[]>({
    ...options,
    queryKey: ["google-sync-events", app.client!.uuid],
    queryFn: () => getGoogleCalendarEvent(app.user!.uuid, clientId, minDateTime, maxDateTime),
  });
}
